export function parseDataSheet(sheet, options) {
  const { keepUndefined } = options;
  const data = sheet.data.slice(1);
  const variableNames = data.shift();
  const variableUnits = data.shift();
  const variables = [];
  for (let j = 0; j < data.length; j++) {
    if (!keepUndefined) {
      let containsUndefined = false;
      for (let i = 0; i < variableNames.length; i++) {
        if (data[j][i] === undefined) {
          containsUndefined = true;
        }
      }
      if (containsUndefined) {
        continue;
      }
    }
    for (let i = 0; i < variableNames.length; i++) {
      variables.push({
        label: variableNames[i],
        units: variableUnits[i],
        data: [],
      });
      variables[i].data.push(data[j][i]);
    }
  }
  return variables;
}

export function checkVariables(parsed, variables) {
  for (let i = 0; i < parsed.length; i++) {
    const targetVariable = variables[Object.keys(variables)[i]];
    if (!targetVariable) {
      continue;
    }
    if (
      parsed[i].label !== targetVariable.label ||
      parsed[i].units !== targetVariable.units
    ) {
      throw new Error(
        `Column ${i} is not ${targetVariable.label} in ${targetVariable.units}`,
      );
    }
  }
}
